import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { GridUpdatePayload } from 'Interfaces/Grid';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: GridUpdatePayload) =>
    $actions.grid.updateGrid(dispatch, values),
  );
};
